// Calendar.js

import React, { useState , useRef, useEffect} from 'react';
import Calendar from '../Calendar/Calendar.jsx';
import SearchbarDash from './SearchbarDash/SearchbarDash.jsx';
import styles from './DiscussAndLearnArea.module.css';

// import './calendarForDiscussAndLearn.css';
import StrangersList from '../../miscellaneous/StrangersList/StrangersList.jsx';
import FriendsList from '../../miscellaneous/FriendsList/FriendsList.jsx';

import PinnedSubjectsDash from './PinnedSubjectsDash/PinnedSubjectsDash.jsx';
import SessionClickedOverlayForDiscussAndLearn from './SessionClickedOverlayForDiscussAndLearn/SessionClickedOverlayForDiscussAndLearn.jsx';
import SessionBookedOverlayForDiscussAndLearn from './SessionBookedOverlayForDiscussAndLearn/SessionBookedOverlayForDiscussAndLearn.jsx';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import { axiosInstance } from '../../../lib/axiosInstance.js';
import dayjs from 'dayjs';


//----------------------------------------------------------------------------
function DiscussAndLearnArea(props) {
  const {isMobile, showFriendsList, setShowFriendsList, showStrangersList, showMyProfile, clickedGridTimeInDayHourMinute, setClickedGridTimeInDayHourMinute, subject, category, datesWithDayMonthYear} = useGlobalState();

  //console.log("cccccccclickedGridTimeInDayHourMinute : "+JSON.stringify(clickedGridTimeInDayHourMinute, null, 2));


  const [allSessions, setAllSessions]=useState([]);   
  const [strangersListSessions, setStrangersListSessions]=useState([]); 
  const [mySessions, setMySessions] = useState([]);



  // Function to convert the time.
  function convertTimeToIndividualUnits(array) {
    return array.map(item => {
      const date = new Date(item.time);     //Based on the OS timezone.
      return {
        day: date.getDate(),
        month: date.getMonth() + 1, // Months are zero-indexed
        year: date.getFullYear(),
        hour: date.getHours(),
        minutes: date.getMinutes(),
        ...item // Spread the original object properties
      };
    });
  }
  

  // Function to filter out future sessions and convert the time.
  function convertTimeToIndividualUnitsAndFilterFutureSessions(array) {
    const currentTime = new Date();
  
    return array
      .filter(item => new Date(item.time) >= currentTime) // Filter items with time >= current time
      .map(item => {
        const date = new Date(item.time);
        return {
          day: date.getDate(),
          month: date.getMonth() + 1, // Months are zero-indexed
          year: date.getFullYear(),
          hour: date.getHours(),
          minutes: date.getMinutes(),
          ...item // Spread the original object properties
        };
      });
  }



  //Below also have to add the list of people to be shown in the strangersList by segregating using time using "clickedGridTimeInDayHourMinute" global state and send it to StrangersList component. 
  useEffect(()=>{
    async function getSessions(){
      try {
        if (datesWithDayMonthYear && (datesWithDayMonthYear.length === 7 || datesWithDayMonthYear.length === 1 ) ){    //Is this really needed?

          //---------------calling "api/sessions"-----------------
          //const response = await axiosInstance.get(`/sessions?startDate=2024-12-23&endDate=2024-12-29&subject=${subject}`);
        
          let calendarStartDate;
          let calendarEndDate;
          if (datesWithDayMonthYear.length === 7) {
            // Access the first and seventh values
            calendarStartDate = datesWithDayMonthYear[0];
            calendarEndDate = datesWithDayMonthYear[6];
          } else if (datesWithDayMonthYear.length === 1) {
            // Access the first value
            calendarStartDate = datesWithDayMonthYear[0];
            calendarEndDate = datesWithDayMonthYear[0];   //If we give 0 here backend will give bad request error.
          }

          //const startDate = `${calendarStartDate.year}-${calendarStartDate.month}-${calendarStartDate.dayNumber}`;
          //const endDate = `${calendarEndDate.year}-${calendarEndDate.month}-${calendarEndDate.dayNumber}`;

          const startDate = dayjs(`${calendarStartDate.year}-${calendarStartDate.month}-${calendarStartDate.dayNumber}`).format('YYYY-MM-DD');
          const endDate = dayjs(`${calendarEndDate.year}-${calendarEndDate.month}-${calendarEndDate.dayNumber}`).format('YYYY-MM-DD');

          // const startDate = `${calendarStartDate.year}-${calendarStartDate.month.padStart(2, '0')}-${calendarStartDate.dayNumber.padStart(2, '0')}`;
          // const endDate = `${calendarEndDate.year}-${calendarEndDate.month.padStart(2, '0')}-${calendarEndDate.dayNumber.padStart(2, '0')}`;

          //console.log(`1Fetching sessions from ${JSON.stringify(calendarStartDate)} to ${JSON.stringify(calendarEndDate)}`);
          console.log(`Fetching sessions from ${startDate} to ${endDate}`);


          const response = await axiosInstance.get(`/sessions?startDate=${startDate}&endDate=${endDate}&subject=${subject}&type=${(category==='discuss_and_learn')?'Discuss and learn with partner':'Silent study with partner'}`);   //Actually because it is Discuss and learn silent study is not needed right?

          //const response = await axiosInstance.get('/sessions?startDate=2024-12-23&endDate=2024-12-29');   
          //const response = await axiosInstance.get('/sessions');    //You have to give {category : , subject:  , start date of the week: } here after Sameedh has added the ability to give paramters.


          console.log("allSessions response.data : "+JSON.stringify(response.data, null, 2));
          console.log("allSessions number response.data : "+JSON.stringify(response.data.length));
          //Maybe we should add await below.
          const DandLConvertedArrayOfIndividualTimeUnits = convertTimeToIndividualUnitsAndFilterFutureSessions(response.data);   //converting mongodb time to day month year time.
          setAllSessions(DandLConvertedArrayOfIndividualTimeUnits);

          //DandLConvertedArrayOfIndividualTimeUnits = convertTimeArray(DandLCalenderArray);

          console.log("7 DandLConvertedArrayOfIndividualTimeUnits : "+JSON.stringify(DandLConvertedArrayOfIndividualTimeUnits, null, 2));





          //--------Filtering sessions for displaying in stranger's list.---------

          // Parameters for filtering
          /*
          const filterParams = {
            "year": 2024,
            "month": 10,
            "day": 3,
            "hour": 13,
            "minute": 32
          };*/

          const filterParams = clickedGridTimeInDayHourMinute;
          filterParams.subject = subject;
          filterParams.type = "Discuss and learn with partner";    //"discuss_and_learn" in front end "Discuss and learn with partner" in backend.
          //console.log("ffffffffffilterParams : "+JSON.stringify(filterParams, null, 2));

          const sessions = DandLConvertedArrayOfIndividualTimeUnits;

          // Function to filter sessions based on parameters
          const filteredSessions = sessions.filter(session =>
            session.year === filterParams.year &&
            session.month === filterParams.month &&
            session.day === filterParams.dayNumber &&
            session.hour === filterParams.hour &&
            session.minutes === filterParams.minute
          );

          setStrangersListSessions(filteredSessions);





          //Maybe we should call the '/sessions/mine' api given below when we close strangerList. So it needs to be here I guess. Or because web socket is not yet done.
          //---------------calling "api/sessions/mine"-----------------

          const mineResponse = await axiosInstance.get('/sessions/mine'); 
          setMySessions(convertTimeToIndividualUnits(mineResponse.data));
        } else {
          console.error("datesWithDayMonthYear array is not properly defined or has insufficient elements.");
          return;
        }

      } catch (error) {
        console.log("error from discussAndLearnArea : "+error);
      }
    }

    // Call getSessions immediately
    getSessions();

    // Set up interval to call getSessions every 10 seconds
    const intervalId = setInterval(getSessions, 10000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  },[category, subject, showStrangersList, datesWithDayMonthYear])   //Add calendar left arrow and right arrow click state here.

  


  //{(showFriendsList===true)&&(<FriendsList/>)}
  return(
    <div className={styles.main_div}>
      {/*----------------Render strangers list (note the class used for now is fl)--------------- */}
      {/*(showStrangersList===true)&&(<StrangersList ref={showStrangersListRef}/>)*/}
      {(showStrangersList===true)&&(<StrangersList bookedPeopleSessionsList={strangersListSessions}/>)}

      {/*----------------Render friends list  (note the class used for now is fl)--------------- */}
      {/*(showFriendsList===true)&&(<FriendsList ref={showFriendsListRef}/>)*/}
      {(showFriendsList===true)&&(<FriendsList/>)}

      {/* {showMyProfile && <MyProfile/>} */}      {/*Has been put in MatrixDisplayArea.jsx*/}


      {/*----------------Subjects display area--------------- */}
      <PinnedSubjectsDash/>


      {/*----------------Calendar top dash div--------------- */}
      <SearchbarDash/>


      {/*----------------Calendar--------------- */}
      <Calendar calendarHeightProp={styles.calendar_height} calendarSessionArrayProp={allSessions} mySessions={mySessions} SessionClickedOverlayBox={SessionClickedOverlayForDiscussAndLearn} SessionBookedOverlayBox={SessionBookedOverlayForDiscussAndLearn}/>

    </div>
  )
}

export default DiscussAndLearnArea;












  //POST
  // [
  //   {
  //     "subject":"Guitar",
  //     "topic": "guitar practice",
  //     "day":4,
  //     "month":10,
  //     "year":2024,
  //     "hour":2,
  //     "minutes":30,
  //     "mode":"Public",
  //     "type":"Discuss and learn with partner",
  //     "requestFriends":[]
  //   }
  // ]


  //GET
  // [
  //   {
  //     "time": "2024-10-03T21:00:00.000Z",
  //     "mode": "Public",
  //     "type": "Discuss and learn with partner",
  //     "topic": "guitar practice",
  //     "subject": "Guitar",
  //     "createdBy": "66f47f658ac955d8dfbd968e",
  //     "isPaired": false,
  //     "_id": "66fd3c156b2e10405d0e3974",
  //     "__v": 0
  //     "pairedWith": "66f47f658ac955d8dfbd968e"
  //   }
  // ];


  //After time conversion here.
  // [
  //   {
  //     "day": 3,
  //     "month": 10,
  //     "year": 2024,
  //     "hour": 21,
  //     "minutes": 0,
  //     "_id": "66fd3c156b2e10405d0e3974",
  //     "time": "2024-10-03T21:00:00.000Z",
  //     "mode": "Public",
  //     "type": "Discuss and learn with partner",
  //     "topic": "guitar practice",
  //     "subject": "Guitar",
  //     "createdBy": "66f47f658ac955d8dfbd968e",
  //     "isPaired": false,
  //     "__v": 0
  //     "pairedWith": "66f47f658ac955d8dfbd968e"
  //   }
  // ]














//--------------------------------------------------------
//Initial fetch using api call. Then real-time listening.


// import React, { useEffect, useState } from 'react';
// import io from 'socket.io-client';
// import axios from 'axios';

// const socket = io('http://localhost:8000');    //'process.env.REACT_APP_BASE_URL' should be used here.

// const RealTimeSessions = () => {
//   const [sessions, setSessions] = useState([]);

//   // Fetch initial session data from the API
//   useEffect(() => {
//     axiosInstance.get('/sessions')
//       .then(response => {
//         setSessions(response.data);
//       })
//       .catch(error => {
//         console.error('Error fetching initial session data:', error);
//       });
//   }, []);

//   // Listen for real-time session updates via WebSocket
//   useEffect(() => {
//     socket.on('sessionUpdate', (newSession) => {
//       setSessions((prevSessions) => [...prevSessions, newSession]);
//     });

//     // Clean up the WebSocket connection
//     return () => {
//       socket.off('sessionUpdate');
//     };
//   }, []);

//   return (
//     <div>
//       <h1>Real-time Sessions</h1>
//       <ul>
//         {sessions.map((session, index) => (
//           <li key={index}>
//             Session ID: {session.id}, Name: {session.sessionName}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default RealTimeSessions;
